import React from "react";
import {
  BooleanField,
  Datagrid,
  DateField,
  DeleteButton,
  Filter,
  List,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
  useTranslate,
} from "react-admin";
import { ViewImage } from "./view-image";
const CmrFilter = (props: any) => {
  const translate = useTranslate();

  return (
    <Filter {...props}>
      <ReferenceInput
        source="accountId"
        perPage={null}
        label={translate("commons.name")}
        sort={{ field: "nom", order: "ASC" }}
        reference="Accounts"
        alwaysOn
      >
        <SelectInput optionText="nom" />
      </ReferenceInput>
    </Filter>
  );
};

export const PleinList = (props) => {
  const translate = useTranslate();
  return (
    <List {...props} filters={<CmrFilter />}>
      <Datagrid>
        <TextField source="id" />
        <ReferenceField
          source="accountId"
          reference="Accounts"
          label={translate("commons.driver")}
        >
          <TextField source="nom" />
        </ReferenceField>
        <TextField
          source="autreStation"
          label={translate("commons.autreStation")}
        />
        <TextField source="type" />
        <TextField source="kilometrageauto" />
        <TextField source="litrageauto" />
        <DateField source="dateheureauto" showTime />
        <ReferenceField
          source="cMRId"
          reference="CMRs"
          label={translate("commons.image")}
          link={false}
        >
          <ViewImage source="image" containerId="cmrs" />
        </ReferenceField>
        <TextField source="kilometrage" />
        <TextField source="litrage" />
        <TextField source="station" />
        <BooleanField source="complet" />
        <ReferenceField
          label={translate("commons.moteur")}
          source="moteurId"
          reference="Moteurs"
        >
          <TextField source="id" />
        </ReferenceField>
        <ReferenceField
          label={translate("commons.tracte")}
          source="tracteId"
          reference="Tractes"
        >
          <TextField source="id" />
        </ReferenceField>
        <DateField
          source="createdAt"
          label={translate("commons.createdAt")}
          showTime
        />
        <DateField
          source="updatedAt"
          label={translate("commons.updatedAt")}
          showTime
        />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
